import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry from "../../../sections/DirectiveEntry/entries/DiagnosticEntry";

const DiagnosticEntryOnGoingDirective = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry />
    </>
  );
}

export default DiagnosticEntryOnGoingDirective;
